import {
  MIGRATION_START,
  MIGRATION_SUCCESS,
  MIGRATION_ERROR,
  MIGRATION_INIT,
  MIGRATION_FUNC_START,
  MIGRATION_TIMEOUT
} from '../actions/MigrationProcessActions';

export const initialState = {
  migrationStatus: null
};
export const MIGRATION_STATUS = {
  STARTED: 'started',
  SUCCESS: 'success',
  ERROR: 'error',
  TIMED_OUT: 'timeout'
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case MIGRATION_FUNC_START:
    case MIGRATION_START:
      return {
        ...state,
        migrationStatus: MIGRATION_STATUS.STARTED
      };
    case MIGRATION_SUCCESS:
      return {
        ...state,
        migrationStatus: MIGRATION_STATUS.SUCCESS
      };
    case MIGRATION_ERROR:
      return {
        ...state,
        migrationStatus: MIGRATION_STATUS.ERROR
      };
    case MIGRATION_TIMEOUT:
      return {
        ...state,
        migrationStatus: MIGRATION_STATUS.TIMED_OUT
      };
    case MIGRATION_INIT:
      return {
        ...initialState
      };
    default:
      return state;
  }
}
